module.exports = __webpack_public_path__ + "static/media/arrow_drop_down.ac33d22a.svg";